import * as PIXI from 'pixi.js';
import gsap from 'gsap';
import { action, autorun, makeObservable, observable, reaction } from 'mobx';
import { GAME_SPEED_TYPES } from '../../constants/gameConstants';
import { gameStore } from '../../../store/gameStore';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { gameDrawer } from '../../../services/gameDrawer';
import { AnimationConfigs, reelsParams } from '../../constants/reelConstants';
import { SpinIconNumberProvider } from '../../helpers/spinIconNumberProvider';
import { SlotIcon } from '../slotIcon';
import { iconStates, specialIconKeys } from '../../constants/symbolsNames';
import { soundService, SoundTypes } from '../../../services/soundService';
import { gameResourcesService } from '../../../services/gameResourcesService';

export class Reel extends PIXI.Container {
  canStop = true;

  isForceStop = false;

  canRotate = false;

  stopComplete = false;

  rotating = false;

  reelInited = false;

  responseReady = false;

  constructor({ index, reelsContainer, slotWinLayer, isLastReel }) {
    super();
    makeObservable(this, {
      canStop: observable,
      isForceStop: observable,
      responseReady: observable,
      rotating: observable,
      stopComplete: observable,
      canRotate: observable,
      reelInited: observable,

      setStopComplete: action,
      setResponseReady: action,
      setRotating: action,
      setCanStop: action,
      setCanRotate: action,
      setIsForceStop: action,
      setReelInited: action,
    });
    this.index = index;
    this.reelsContainer = reelsContainer;
    this.winContainer = slotWinLayer;
    this.isLastReel = isLastReel;
    this.AnimationConfigs = AnimationConfigs;
    this.iconNumberProvider = new SpinIconNumberProvider(index);
    this.iconsHeight = reelsParams[index].iconsHeight;
    this.iconsInReel = reelsParams[index].iconsInReel;
    this.visibleRows = reelsParams[index].visibleRows;
    this.speedDuration = reelsParams[index].speedDuration;
    this.iconsWidth = reelsParams[index].iconsWidth;
    this.iconsSpacing = reelsParams[index].iconsSpacing;
    this.spacing = reelsParams[index].spacing;
    this.xPosition = 0;
    this.icons = [];
    this.iconContainers = [];
    this.matrix = [];
    this.firstLoop = true;
    this.vector = true;
    this.inStopAnimation = false;
    this.finalDrawCardNumbers = [];
    this.initReactions();
    this.initReel();
    const { posStart, posEnd, duration, posEndStop, stopEase, stopDuration } =
      this.checkPositionsAndDuration();
    this.posStart = posStart;
    this.posEnd = posEnd;
    this.duration = duration;
    this.posEndStop = posEndStop;
    this.stopEase = stopEase;
    this.stopDuration = stopDuration;
    this.spinCounter = 0;
  }

  positionAndDurationCheck() {
    const { posStart, posEnd, duration, posEndStop, stopEase, stopDuration } =
      this.checkPositionsAndDuration();
    this.posStart = posStart;
    this.posEnd = posEnd;
    this.duration = duration;
    this.posEndStop = posEndStop;
    this.stopEase = stopEase;
    this.stopDuration = stopDuration;
  }

  initReactions() {
    this.reactions = [];
    this.reactions.push(
      reaction(
        () => bettingPartStore.gameSpeedType,
        (speedType) => {
          const { posStart, posEnd, duration, posEndStop, stopEase, stopDuration } =
            this.checkPositionsAndDuration();
          this.posStart = posStart;
          this.posEnd = posEnd;
          this.duration = duration;
          this.posEndStop = posEndStop;
          this.stopEase = stopEase;
          this.stopDuration = stopDuration;
        }
      )
    );

    // this.reactions.push(
    //   reaction(
    //     () => this.canStop,
    //     (canStop) => {}
    //   )
    // );
    this.reactions.push(
      reaction(
        () => this.isForceStop,
        (isForceStop) => {
          if (isForceStop && this.rotating) {
            this.TurboStop(true);
          }
        }
      )
    );
    // this.reactions.push(
    //   reaction(
    //     () => gameStore.canStop,
    //     (canStop) => {
    //       if (canStop && this.responseReady && gameDrawer.isForceStop) {
    //         this.TurboStop(true);
    //       }
    //     }
    //   )
    // );
    this.reactions.push(
      reaction(
        () => this.responseReady,
        (responseReady) => {
          if (responseReady && bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.turbo) {
            this.TurboStop(true);
          }
        }
      )
    );
    // autorun(() => {
    //   if (
    //     this.responseReady &&
    //     !this.firstLoop &&
    //     this.index === 0 &&
    //     bettingPartStore.gameSpeedType !== GAME_SPEED_TYPES.turbo &&
    //     !gameStore.isForceStop
    //   ) {
    //     this.StopAnim(true);
    //   }
    // });
    this.reactions.push(
      reaction(
        () => this.canRotate,
        (canRotate) => {
          if (canRotate) {
            this.setStopComplete(false);
            this.startSpin();
          }
        }
      )
    );
    this.reactions.push(
      reaction(
        () => this.rotating,
        (rotating) => {
          if (rotating) {
          }
        }
      )
    );
    this.reactions.push(
      reaction(
        () => this.reelInited,
        async (inited) => {
          if (inited) {
            if (this.index !== 0) this.setCanStop(false);
            await this.fillIconsFinalPositionsConfigArray();
            this.positionAndDurationCheck();
            this.initIconsPositions();
          }
        }
      )
    );
    this.reactions.push(
      reaction(
        () => this.stopComplete,
        (complete) => {
          if (complete) {
            this.inStopAnimation = false;
            this.setRotating(false);
            if (this.index !== 0) this.setCanStop(false);
            if (this.index === reelsParams.length - 1) gameDrawer.setReelsStoped();
          }
        }
      )
    );
  }

  async initReel() {
    this.initContainerPosition();
    await this.addReelIcons(gameStore.gameInitialMatrix[this.index]);
    if (this.index !== 0) this.setCanStop(false);
    this.setReelInited(true);
  }

  initContainerPosition() {
    this.xPosition = this.index * (this.iconsWidth + (this.index === 0 ? 0 : this.spacing));
    this.xPosition += reelsParams[this.index].offsetForContainerBoardWidth;
    reelsParams[this.index].finalPositionX = this.xPosition;

    this.startPositionY =
      -(this.iconsHeight + this.iconsSpacing) * this.visibleRows - this.iconsSpacing * 2;
    reelsParams[this.index].finalPositionY = -this.iconsHeight * (this.visibleRows - 1);
    this.startPositionY += reelsParams[this.index].offsetForContainerBoardHeight;
    this.setContainerPos(this.startPositionY, this.xPosition);

    this.reelsContainer.addChild(this);
  }

  setContainerPos(posY, posX = this.xPosition) {
    this.position.set(posX, posY);
  }

  createIconContainers() {
    for (let i = 0; i < this.iconsInReel; i++) {
      const tempContainer = new PIXI.Container();
      tempContainer.name = 'iconContainer';
      this.iconContainers.push(tempContainer);
      this.addChild(tempContainer);
    }
  }

  initIconsPositions() {
    this.icons.forEach((icon, index) => {
      icon.setWinContainerPositions(
        reelsParams[this.index].iconsFinalPositions.inWinContainer[index]
      );
    });
  }

  addReelIcons(matrix) {
    const updatedMatrix = this.changeMatrixMode(matrix);
    this.createIconContainers();
    for (let i = 0; i < this.iconContainers.length; i++) {
      const tempIcon = this.createSymbol(
        this.iconContainers[i],
        this.iconsHeight + this.iconsSpacing,
        updatedMatrix[i],
        this.index,
        i
      );
      this.icons.push(tempIcon);
    }
  }

  createSymbol(container, height, key, index, elementIndex) {
    return new SlotIcon({
      parent: container,
      elementId: `spinIcon_${index}_${elementIndex + 1}`,
      rowIndex: elementIndex,
      winParent: this.winContainer,
      styles: { x: 0, y: elementIndex * height },
      reelIndex: index,
      index: key,
      key: key,
    });
  }

  changeMatrixMode(matrix) {
    const optionalMatrix = [];
    for (let i = 0; i < this.visibleRows; i++) {
      optionalMatrix.push(this.iconNumberProvider.getNext(this.index));
    }
    return [...optionalMatrix, ...matrix, ...optionalMatrix];
  }

  startSpin() {
    this.setCanRotate(false);
    this.firstLoop = true;
    this.vector = gameDrawer.spinDirection === 1;
    this.rotateLoop();
  }

  setRandomSymbolsOnStart() {
    const totalSymbols = this.iconsInReel;
    const visibleCount = this.visibleRows;
    const symbolsVisible = new Array(visibleCount);
    let state = 'blur';

    for (let i = visibleCount; i < visibleCount * 2; i++) {
      const isWild = this.icons[i].key === specialIconKeys.wild;
      if (isWild && Object.values(iconStates.idleExpand).includes(this.icons[i].currentState)) {
        state = this.icons[i].currentState;
      }
      symbolsVisible[i - visibleCount] = this.icons[i].key;
      this.icons[i].changeToActualParent();
    }

    if (this.vector) {
      for (let i = visibleCount * 2, j = 0; i < totalSymbols; i++, j++) {
        this.icons[i].changeIcon(symbolsVisible[j], state);
      }
      const replacementLimit = totalSymbols - visibleCount;
      for (let i = 0; i < replacementLimit; i++) {
        this.icons[i].changeIcon(this.iconNumberProvider.getNext(this.index), 'blur');
      }
    } else {
      for (let i = 0; i < visibleCount; i++) {
        const isWild = this.icons[i].key === specialIconKeys.wild;
        if (isWild && Object.values(iconStates.idleExpand).includes(this.icons[i].currentState)) {
          state = this.icons[i].currentState;
        }
        this.icons[i].changeIcon(symbolsVisible[i], state);
      }
      for (let i = visibleCount; i < totalSymbols; i++) {
        this.icons[i].changeIcon(this.iconNumberProvider.getNext(this.index), 'blur');
      }
    }
  }

  rotateLoop() {
    if (this.responseReady && bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.turbo) {
      return;
    }
    this.setRandomSymbolsOnStart();
    const isFast = bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.fast;
    if (!isFast) {
      this.setContainerPos(this.vector ? this.posStart : this.posEnd);
    } else {
      this.setContainerPos(
        this.vector ? this.posStart : this.posEnd + this.visibleRows * this.iconsHeight
      );
    }
    this.animation = gsap.to(this, {
      duration: this.duration,
      repeatDelay: 0.0001,
      immediateRender: true,
      pixi: { y: this.vector ? this.posEnd : isFast ? this.posEnd : this.posStart },
      ease: 'linear',
      repeat: -1,
      onRepeat: () => {
        this.loopBeginAnimation();
      },
    });
  }

  loopBeginAnimation = () => {
    if (this.canStop && gameStore.canStop && !this.firstLoop) {
      this.chooseStopAnim();
    }
    if (!this.inStopAnimation) {
      if (bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.standard) {
        this.createRandomSymbolsOnLoopMode({
          slice: [0, this.visibleRows],
          count: this.visibleRows * 2,
        });
      } else if (bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.fast) {
        this.createRandomSymbolsOnLoopMode({
          slice: [this.visibleRows, this.visibleRows * 2],
          count: this.visibleRows * 2,
        });
      } else if (bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.turbo) {
        this.createRandomSymbolsOnLoopMode({
          slice: [0, this.visibleRows],
          count: this.visibleRows * 2,
        });
      }
    }
    if (this.firstLoop) {
      this.firstLoop = false;
    }
  };

  resetReel() {
    this.setIsForceStop(false);
    this.setResponseReady(false);
  }

  checkPositionsAndDuration() {
    switch (bettingPartStore.gameSpeedType) {
      case GAME_SPEED_TYPES.standard:
        return {
          posStart: this.startPositionY - this.visibleRows * this.iconsHeight,
          posEnd: this.startPositionY + this.visibleRows * this.iconsHeight,
          duration: this.speedDuration,
          stopDuration: this.speedDuration * 1.35,
          stopEase: this.AnimationConfigs.stopNormal,
          posEndStop: this.startPositionY,
        };
      case GAME_SPEED_TYPES.fast:
        return {
          posStart: this.startPositionY - this.visibleRows * this.iconsHeight,
          posEnd: this.startPositionY,
          duration: this.speedDuration / 3,
          stopDuration: this.speedDuration * 1.5,
          stopEase: this.AnimationConfigs.stopFast,
          posEndStop: this.startPositionY,
        };
      case GAME_SPEED_TYPES.turbo:
        return {
          posStart: this.startPositionY - this.visibleRows * this.iconsHeight,
          posEnd: this.startPositionY + this.visibleRows * this.iconsHeight,
          duration: this.speedDuration,
          stopDuration: this.speedDuration,
          stopEase: this.AnimationConfigs.stopTurbo,
          posEndStop: this.startPositionY,
        };
      default:
        return {
          posStart: this.startPositionY,
          posEnd: this.startPositionY,
          duration: this.speedDuration,
          stopDuration: this.speedDuration,
          stopEase: 'linear',
          posEndStop: this.startPositionY,
        };
    }
  }

  createRandomSymbolsOnLoopMode(symbolsConf) {
    const getIconKey = (icon) => icon.key;

    const arr = this.vector
      ? this.icons.slice(symbolsConf.slice[0], symbolsConf.slice[1]).map(getIconKey)
      : this.icons
          .slice(this.iconsInReel - symbolsConf.slice[1], this.iconsInReel - symbolsConf.slice[0])
          .map(getIconKey);

    const [startIdx, endIdx] = this.vector
      ? [this.visibleRows * 2, this.visibleRows * 3]
      : [0, this.visibleRows];

    for (let i = startIdx; i < endIdx; i += 1) {
      this.icons[i].changeIcon(arr[i - startIdx], 'blur');
    }

    const randomSlice = this.vector
      ? this.icons.slice(0, symbolsConf.count)
      : this.icons.slice(this.visibleRows, this.visibleRows + symbolsConf.count);

    randomSlice.forEach((icon) => {
      icon.changeIcon(this.iconNumberProvider.getNext(this.index), 'blur');
    });
  }

  chooseStopAnim() {
    const isTurbo = bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.turbo;
    if (!isTurbo) {
      this.StopAnim();
    }
  }

  setWinMatrixForStop(isFromResponseReady) {
    const isTurboOrStandard =
      bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.turbo ||
      bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.standard;
    const reelIcons = this.icons.slice(0, this.visibleRows * 3);
    const copySymbols = [];

    if (this.vector) {
      reelIcons.forEach((icon, i) => {
        let iconNumber;
        if (i < this.visibleRows) {
          if (isTurboOrStandard && !isFromResponseReady) {
            copySymbols.push(this.icons[i].iconNumber);
          }
          iconNumber = this.iconNumberProvider.getNext(this.index);
        } else if (i < this.visibleRows * 2) {
          if (!isTurboOrStandard || isFromResponseReady) {
            copySymbols.push(this.icons[i].key);
          }
          iconNumber = this.finalDrawCardNumbers[i - this.visibleRows];
        } else {
          iconNumber = copySymbols[i - this.visibleRows * 2];
        }
        icon.changeIcon(iconNumber, 'blur');
      });
    } else {
      for (let i = this.visibleRows * 2; i < this.iconsInReel; i++) {
        let iconNumber;
        if (isTurboOrStandard && !isFromResponseReady) {
          copySymbols.push(this.icons[i].iconNumber);
        }
        iconNumber = this.iconNumberProvider.getNext(this.index);
        this.icons[i].changeIcon(iconNumber, 'blur');
      }
      for (let i = this.visibleRows; i < this.visibleRows * 2; i++) {
        if (!isTurboOrStandard || isFromResponseReady) {
          copySymbols.push(this.icons[i].key);
        }
        const iconNumber = this.finalDrawCardNumbers[i - this.visibleRows];
        this.icons[i].changeIcon(iconNumber);
      }
      for (let i = 0; i < this.visibleRows; i++) {
        this.icons[i].changeIcon(copySymbols[i], 'blur');
      }
    }
  }

  setSymbolsNonBlur() {
    for (let i = this.visibleRows - 1; i < this.visibleRows * 2 + 1; i++) {
      this.icons[i].changeState(iconStates.idle, this.icons[i].iconNumber === specialIconKeys.wild);
    }
  }

  StopAnim(isFromResponseReady = false) {
    if (this.inStopAnimation) return;
    this.inStopAnimation = true;
    const isFast = bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.fast;
    this.setWinMatrixForStop(isFromResponseReady);
    this.setSymbolsNonBlur();
    if (this.animation) this.animation.kill();
    if (isFromResponseReady) {
      this.setContainerPos(this.vector ? this.posStart : this.posEnd);
    }
    this.animation = gsap.to(this, {
      pixi: { y: this.posEndStop },
      duration: this.stopDuration,
      ease: this.stopEase,
      onStart: async () => {
        if (this.index !== reelsParams.length - 1) {
          gameDrawer.enableNextReelStop(this.index);
        }
        this.playSoundForSpecialSymbols();
        await new Promise((resolve) => setTimeout(resolve, isFast ? 160 : 120));
        soundService.play(SoundTypes.ReelStop);
      },
      onComplete: () => {
        this.setStopComplete(true);
      },
    });
  }

  playSoundForSpecialSymbols() {
    if (this.finalDrawCardNumbers.some((number) => number === specialIconKeys.wild)) {
      soundService.play(SoundTypes.WildSymbol);
    }
    if (this.finalDrawCardNumbers.some((number) => number === specialIconKeys.scatter1)) {
      if (this.index <= 2) {
        gameDrawer.scatter1Count += 1;
        soundService.play(SoundTypes.Scatter1Win);
      } else if (gameDrawer.scatter1Count && this.index === 3) {
        this.scatter1Count += 1;
        soundService.play(SoundTypes.Scatter1Win);
      } else if (gameDrawer.scatter1Count > 2 && this.index === 4) {
        soundService.play(SoundTypes.Scatter1Win);
      }
    } else if (this.finalDrawCardNumbers.some((number) => number === specialIconKeys.scatter2)) {
      if (this.index === 0) {
        gameDrawer.scatter2Count += 1;
        soundService.play(SoundTypes.Scatter2Win);
      }
      if (!(this.index % 2) && this.index !== 0 && gameDrawer.scatter2Count) {
        soundService.play(SoundTypes.Scatter2Win);
      }
    }
  }

  TurboStop(isFromRandomPosition = false) {
    if (this.inStopAnimation) return;
    this.inStopAnimation = true;
    this.setWinMatrixForStop();
    this.setSymbolsNonBlur();
    this.vector = gameDrawer.spinDirection === 1;
    const isFast = bettingPartStore.gameSpeedType === GAME_SPEED_TYPES.fast;
    if (this.animation) this.animation.kill();
    if (isFromRandomPosition) {
      this.setContainerPos(
        this.vector
          ? this.posStart
          : isFast
          ? this.posEnd + this.visibleRows * this.iconsHeight
          : this.posEnd
      );
    }
    this.animation = gsap.to(this, {
      pixi: { y: this.posEndStop },
      duration: this.stopDuration,
      ease: this.stopEase,
      onStart: async () => {
        this.playSoundForSpecialSymbols();
        await new Promise((resolve) => setTimeout(resolve, 50));
        if (gameStore.isForceStop) {
          soundService.play(SoundTypes.ReelStop);
        } else {
          if (!this.index) {
            soundService.play(SoundTypes.ReelStop);
          }
        }
      },
      onComplete: () => {
        this.setStopComplete(true);
      },
    });
  }

  move(moveAmount) {
    this.y += moveAmount;
  }

  initFromResponseData(matrix) {
    const responseData = matrix && matrix[this.index];
    if (!responseData) return;
    this.finalDrawCardNumbers = [...responseData];
    this.setResponseReady(true);
  }

  fillIconsFinalPositionsConfigArray() {
    const reel = reelsParams[this.index];
    reel.iconsFinalPositions.inWinContainer = [];
    reel.iconsFinalPositions.inReel = [];
    for (let i = 0; i < this.iconsInReel; i++) {
      const xInReel = this.icons[i].xPosInReel;
      const yInReel = this.icons[i].yPosInReel;
      reel.iconsFinalPositions.inReel.push({ xInReel, yInReel });
    }
    for (let i = 0; i < this.iconsInReel; i++) {
      const xInWin = reel.finalPositionX;
      const yInWin =
        (this.icons[i].rowIndex - reel.visibleRows) *
        (reelsParams[this.icons[i].reelIndex].iconsHeight -
          reelsParams[this.icons[i].reelIndex].iconsSpacing);
      reel.iconsFinalPositions.inWinContainer.push({ xInWin, yInWin });
    }
  }

  setCanStop(bool) {
    this.canStop = bool;
  }

  setCanRotate(bool) {
    this.canRotate = bool;
  }

  setRotating(bool) {
    this.rotating = bool;
  }

  setStopComplete(bool) {
    this.stopComplete = bool;
  }

  setReelInited(bool) {
    this.reelInited = bool;
  }

  setIsForceStop(bool) {
    this.isForceStop = bool;
  }

  setResponseReady(bool) {
    this.responseReady = bool;
  }
}
